import React, { useEffect } from 'react';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';

const AppRoute = ({ component: Component, blankLayout, ...props }) => {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(onBlankLayout(!!blankLayout));

		return () => {
			dispatch(onBlankLayout(false));
		};

	}, [blankLayout, dispatch]);

	return <Component {...props} />;
};

export default AppRoute;
